export const publicEndpoints = ['/banners', '/public-hankkeet'];
